import { useQuery } from '@tanstack/react-query';
import OrganizationService from '@services/Organization/organization.service';

export const usePositions = (brandId: number | null, departmentId: number | null) => {
  return useQuery({
    queryKey: ['positions', brandId, departmentId],
    queryFn: ({ signal }) => OrganizationService.getPositionsByBrandAndDepartment(brandId!, departmentId!, signal),
    enabled: !!brandId && !!departmentId, 
    staleTime: 60 * 60 * 1000, 
    gcTime: 65 * 60 * 1000, 
  });
};